export default __webpack_public_path__ + "static/home-time-image-06c1946c7e4c3d435b2e14c6c349f095.png";